import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { resolveTheme, setThemePref, type ResolvedTheme } from "@/lib/theme";
import { Button } from "@/components/ui/button";

// ライト/ダークを切り替えるヘッダー用トグル。現在の実効テーマに応じてアイコンを出し分ける。
export default function ThemeToggle({ className }: { className?: string }) {
  const [theme, setTheme] = useState<ResolvedTheme>("dark");

  useEffect(() => setTheme(resolveTheme()), []);

  const toggle = () => {
    const next: ResolvedTheme = theme === "dark" ? "light" : "dark";
    setThemePref(next);
    setTheme(next);
  };

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={toggle}
      aria-label={theme === "dark" ? "ライトモードに切替" : "ダークモードに切替"}
      className={className}
    >
      {theme === "dark" ? <Sun /> : <Moon />}
    </Button>
  );
}
